import { createFileRoute } from "@tanstack/react-router";
import { MarketingHero } from "@/components/marketing-hero";
import { MarketingPageShell } from "@/components/marketing-page-shell";
import { HomepageAgentInstall } from "@/components/setup/homepage-agent-install";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/claude-social-media";

export const Route = createFileRoute(path)({
	component: ClaudeSocialMedia,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Boost your Social Media using Claude",
			description:
				"Use Claude as an AI social media scheduler. AgentReacher's MCP server lets Claude draft, adapt, approve, schedule, and publish posts across every platform.",
		}),
});

function ClaudeSocialMedia() {
	return (
		<MarketingPageShell>
			<MarketingHero
				agent="claude"
				title="Boost your Social Media using Claude"
				description="AgentReacher gives Claude the tools to turn a campaign brief into a scheduled content calendar. Draft in chat, review the queue, and publish across every connected channel."
				primaryCta={{ label: "Connect Claude", to: "/connect-claude" }}
				secondaryCta={{ label: "Setup docs", to: "/connect-claude" }}
			/>

			<HomepageAgentInstall />
		</MarketingPageShell>
	);
}
